export const privacyPolicy = {
  title: 'POLITICA DE CONFIDENȚIALITATE',
  updatedAt: '2026-09-27',
  text: `Prezenta Politică de Confidențialitate explică modul în care sunt colectate, utilizate, stocate și protejate datele cu caracter personal ale persoanelor care accesează și utilizează website-ul Oranjina Biscotina , inclusiv atunci când utilizează funcția de rezervare.

Protecția datelor cu caracter personal este importantă pentru noi și ne angajăm să prelucrăm datele utilizatorilor în conformitate cu legislația aplicabilă, inclusiv cu Regulamentul (UE) 2016/679 privind protecția datelor cu caracter personal („GDPR”) și legislația națională aplicabilă.

## 1. Cine suntem

Operatorul datelor cu caracter personal prelucrate prin intermediul Website-ului este:

Denumire juridică: EUROINVEST RESOLVE ENTERPRISE S.R.L
CUI: 45381053
Nr. Registrul Comerțului: J2021007921233
Sediu social: Jud. Ilfov, Sat Rosu, Comuna Chiajna, Strada WEINER PALADA , Nr. 1, parter, camera 1, Bl. C1, Ap.20
E-mail: andreeanastasiuc@gmail.com
Telefon: 0784 173 284

Locația Oranjina Biscotina:
Strada Constantin Brâncoveanu 8 A, Mogoșoaia, România

În prezenta Politică, termenii „Oranjina Biscotina”, „noi”, „nostru” sau „Operatorul” se referă la entitatea juridică responsabilă de operarea Website-ului și a locației, identificată mai sus.

## 2. Ce date cu caracter personal putem colecta

În funcție de modul în care utilizați Website-ul, putem prelucra următoarele categorii de date:

- nume și prenume;
- număr de telefon;
- adresă de e-mail;
- informații privind rezervarea, precum data, ora și numărul de persoane;
- informații introduse voluntar în câmpul de observații al unei rezervări;
- informații necesare pentru gestionarea și confirmarea unei rezervări;
- date tehnice asociate utilizării Website-ului, precum adresa IP, tipul dispozitivului, browserul, sistemul de operare și informații privind interacțiunea cu Website-ul, în funcție de instrumentele tehnice utilizate;

Nu solicităm utilizatorilor să furnizeze categorii speciale de date cu caracter personal prin formularul de rezervare. Vă rugăm să nu introduceți în câmpurile libere informații sensibile care nu sunt necesare pentru efectuarea rezervării.

## 3. Datele furnizate pentru rezervări

Website-ul poate permite efectuarea unei rezervări la Oranjina Biscotina.

Pentru procesarea unei rezervări, putem solicita date precum:

- numele persoanei care efectuează rezervarea;
- numărul de telefon;
- adresa de e-mail, dacă este solicitată;
- data și ora dorită;
- numărul de persoane;
- eventuale observații transmise de utilizator.

Aceste informații sunt utilizate pentru a putea înregistra, confirma, modifica sau anula rezervarea și, după caz, pentru a contacta persoana care a efectuat rezervarea în legătură cu aceasta.

Furnizarea datelor marcate ca fiind obligatorii este necesară pentru procesarea rezervării. În lipsa acestor informații, este posibil să nu putem efectua sau confirma rezervarea.

## 4. În ce scop utilizăm datele

Putem utiliza datele cu caracter personal pentru următoarele scopuri:

- gestionarea și administrarea rezervărilor;
- confirmarea, modificarea sau anularea rezervărilor;
- contactarea utilizatorului în legătură cu o rezervare;
- răspunsul la solicitările transmise prin intermediul Website-ului;
- asigurarea funcționării și securității Website-ului;
- prevenirea utilizării abuzive sau frauduloase a Website-ului;
- îmbunătățirea funcționalității și experienței utilizatorilor;
- realizarea de statistici privind utilizarea Website-ului, atunci când sunt utilizate instrumente de analiză;
- îndeplinirea obligațiilor legale aplicabile;
- apărarea sau exercitarea unor drepturi și interese legitime în cadrul unor proceduri legale.

Nu utilizăm datele colectate prin rezervări pentru a trimite comunicări de marketing în scopuri comerciale decât dacă există un temei juridic corespunzător pentru o astfel de prelucrare.

## 5. Temeiul juridic al prelucrării

În funcție de scopul concret, prelucrarea datelor poate avea la bază unul dintre temeiurile prevăzute de GDPR.

### Executarea unei solicitări sau a unui contract

Atunci când datele sunt necesare pentru gestionarea unei rezervări solicitate de utilizator, prelucrarea poate fi necesară pentru efectuarea demersurilor solicitate de acesta înainte de încheierea unui contract sau pentru executarea unui contract, după caz.

### Îndeplinirea obligațiilor legale

În anumite situații, putem prelucra datele pentru respectarea obligațiilor legale care ne revin.

### Interes legitim

Putem prelucra anumite date atunci când acest lucru este necesar pentru interesele noastre legitime, cum ar fi administrarea și securizarea Website-ului, prevenirea fraudelor sau apărarea drepturilor noastre, cu respectarea drepturilor și libertăților persoanelor vizate.

### Consimțământ

Atunci când legislația impune obținerea consimțământului, vom solicita acest consimțământ înainte de prelucrare.

Consimțământul poate fi retras în orice moment, fără ca retragerea să afecteze legalitatea prelucrării efectuate înainte de retragerea acestuia.

## 6. Cui putem transmite datele

În funcție de funcționalitățile Website-ului și de modul în care sunt furnizate serviciile, datele pot fi accesate de:

- personalul autorizat al Oranjina Biscotina;
- furnizorii de servicii IT și de găzduire;
- furnizorul sistemului de rezervări;
- furnizorii de servicii de mentenanță și administrare a Website-ului;
- furnizorii de servicii de analiză sau alte servicii integrate în Website, dacă acestea sunt utilizate;
- autorități publice și alte entități, atunci când transmiterea este impusă de lege.

Nu vindem datele personale ale utilizatorilor.

Furnizorii care prelucrează date în numele nostru vor avea acces numai la datele necesare pentru furnizarea serviciilor respective și, după caz, vor acționa în calitate de persoane împuternicite conform GDPR.

## 7. Transferuri internaționale

În cazul în care anumiți furnizori de servicii utilizați de Website prelucrează date cu caracter personal în afara Spațiului Economic European, transferul se va realiza numai în condițiile prevăzute de GDPR.

În funcție de situație, pot fi utilizate mecanisme precum:

- o decizie de adecvare a Comisiei Europene;
- clauze contractuale standard;
- alte mecanisme recunoscute de legislația aplicabilă.

## 8. Cât timp păstrăm datele

Păstrăm datele cu caracter personal numai atât timp cât este necesar pentru scopurile pentru care au fost colectate sau atât timp cât există o obligație legală de păstrare.

În cazul datelor referitoare la rezervări, acestea pot fi păstrate pentru perioada necesară administrării rezervării și pentru perioadele ulterioare necesare îndeplinirii obligațiilor legale sau apărării drepturilor noastre.

Perioadele exacte de retenție pot varia în funcție de tipul datelor și scopul prelucrării.

## 9. Servicii și conținut furnizat de terți

Website-ul poate conține linkuri către sau elemente furnizate de servicii terțe, cum ar fi rețele sociale, servicii de hărți, sisteme de rezervări, servicii de analiză sau alte platforme.

Interacțiunea cu astfel de servicii poate implica prelucrarea unor date de către operatorii acelor servicii, conform propriilor politici de confidențialitate.

## 10. Securitatea datelor

Luăm măsuri tehnice și organizatorice adecvate pentru protejarea datelor cu caracter personal împotriva accesului neautorizat, pierderii, distrugerii, modificării sau divulgării neautorizate.

Accesul la date este limitat la persoanele și furnizorii care au nevoie de aceste date pentru îndeplinirea atribuțiilor sau furnizarea serviciilor relevante.

Cu toate acestea, nicio metodă de transmitere sau stocare electronică a datelor nu poate garanta un nivel de securitate absolut.

## 11. Drepturile dumneavoastră

În condițiile prevăzute de GDPR, persoanele vizate pot beneficia de următoarele drepturi:

### Dreptul de acces

Aveți dreptul de a solicita informații privind prelucrarea datelor dumneavoastră și, în anumite condiții, o copie a datelor personale pe care le deținem.

### Dreptul la rectificare

Aveți dreptul de a solicita corectarea datelor inexacte sau completarea datelor incomplete.

### Dreptul la ștergerea datelor

În anumite situații, puteți solicita ștergerea datelor dumneavoastră cu caracter personal.

Acest drept nu este absolut și poate exista situația în care anumite date trebuie păstrate pentru îndeplinirea unei obligații legale.

### Dreptul la restricționarea prelucrării

În anumite condiții, puteți solicita limitarea prelucrării datelor dumneavoastră.

### Dreptul la opoziție

Vă puteți opune anumitor prelucrări bazate pe interese legitime, în condițiile prevăzute de GDPR.

### Dreptul la portabilitatea datelor

Atunci când sunt îndeplinite condițiile legale, aveți dreptul de a primi datele furnizate într-un format structurat, utilizat în mod curent și care poate fi citit automat și, dacă este posibil din punct de vedere tehnic, de a solicita transmiterea acestora către un alt operator.

### Dreptul de a retrage consimțământul

Atunci când prelucrarea se bazează pe consimțământ, acesta poate fi retras în orice moment.

Retragerea consimțământului nu afectează legalitatea prelucrării efectuate înainte de retragere.

## 12. Cum vă puteți exercita drepturile

Pentru exercitarea drepturilor sau pentru orice întrebare referitoare la prelucrarea datelor personale, ne puteți contacta la:

E-mail: andreeastasiuc@gmail.com
Telefon: 0767316571
Adresă: Strada Constantin Brâncoveanu 8 A, Mogoșoaia, România

În funcție de natura solicitării, este posibil să solicităm informații suplimentare pentru verificarea identității persoanei care formulează cererea.

Vom răspunde solicitărilor în termenul prevăzut de legislația aplicabilă.

## 13. Dreptul de a depune o plângere

Dacă considerați că prelucrarea datelor dumneavoastră încalcă legislația privind protecția datelor, aveți dreptul de a depune o plângere la autoritatea de supraveghere competentă.

În România, autoritatea competentă este:

Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)

Datele de contact și procedura actuală pentru depunerea unei plângeri sunt disponibile pe website-ul oficial al autorității.

## 14. Utilizarea Website-ului de către minori

Website-ul nu este destinat colectării intenționate de date personale de la copii în lipsa condițiilor prevăzute de legislația aplicabilă.

Dacă un părinte sau reprezentant legal consideră că un minor a furnizat date personale fără respectarea condițiilor legale aplicabile, acesta ne poate contacta folosind datele de contact menționate în prezenta Politică.

## 15. Modificarea Politicii de Confidențialitate

Putem actualiza periodic această Politică de Confidențialitate pentru a reflecta modificări ale Website-ului, ale serviciilor oferite, ale legislației sau ale modului în care sunt prelucrate datele cu caracter personal.

Versiunea actuală va fi publicată pe Website și va include data ultimei actualizări.

Vă recomandăm să consultați periodic această pagină.

## 16. Contact

Pentru întrebări referitoare la această Politică de Confidențialitate sau la modul în care sunt prelucrate datele dumneavoastră, ne puteți contacta:

Oranjina Biscotina
Strada Constantin Brâncoveanu 8 A
Mogoșoaia, România
Telefon: 0784 173 284
E-mail: andreeanastasiuc@gmail.com
Operator: EUROINVEST RESOLVE ENTERPRISE S.R.L
CUI: 45381053
Nr. Registrul Comerțului: J2021007921233`,
};